export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/hero-dfpro-2026.jpg"
          alt="Réparation de baie vitrée coulissante par DFPRO Hérault — intervention sur menuiserie aluminium"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-500/60 via-primary-500/40 to-primary-500/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-2xl">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight mb-6">
            Réparation de baie vitrée coulissante dans l'Hérault
          </h1>
          <p className="text-lg md:text-xl text-white/90 font-body mb-8 leading-relaxed">
            Votre baie coulissante coince, les roulettes grincent, le volet ou le vitrage est en panne à Montpellier ou dans l'Hérault ? Nos techniciens interviennent <strong className="text-white font-semibold">sous 24 à 48h, 7j/7</strong> pour un diagnostic précis et une réparation durable.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="tel:+33980802242" className="btn-call text-base px-8 py-4">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg"></i>
              </span>
              Appeler le 09 80 80 22 42
            </a>
            <a href="tel:+33980802242" className="btn-devis text-base px-8 py-4 border-white text-white hover:bg-white hover:text-primary-500">
              Devis gratuit
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}